module.exports = __webpack_public_path__ + "static/img/com_4.98cddf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/com_4.png
// module id = gXVY
// module chunks = 0